export default __webpack_public_path__ + "static/media/thriving.5db8988e.svg";